import { useQuery } from '@tanstack/react-query';
import {
  getPlatformMetrics,
  getPlatformOrganizations,
  getPlatformOrganization,
  getPlatformUsers,
} from '@/api/platform';
import { queryKeys } from '@/api/queryKeys';

export function usePlatformMetrics() {
  return useQuery({ queryKey: queryKeys.platform.metrics, queryFn: getPlatformMetrics });
}

export function usePlatformOrganizations(params: {
  page?: number;
  per_page?: number;
  search?: string;
  plan?: string;
  status?: string;
}) {
  return useQuery({
    queryKey: queryKeys.platform.organizations(params),
    queryFn: () => getPlatformOrganizations(params),
  });
}

export function usePlatformOrganization(id: string) {
  return useQuery({
    queryKey: queryKeys.platform.organization(id),
    queryFn: () => getPlatformOrganization(id),
    enabled: !!id,
  });
}

export function usePlatformUsers(params: { page?: number; per_page?: number; search?: string }) {
  return useQuery({
    queryKey: queryKeys.platform.users(params),
    queryFn: () => getPlatformUsers(params),
  });
}
